var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-parallax"},[_c('vue-parallax',{attrs:{"intensity":20,"image":require('@/assets/images/bg_parallax.jpg')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }